import api from 'utils/api';
import { TRANSFORMERS_URL } from "api/constants";


export const searchEbook = async (bookUUID, term) => {
    return api.get(
        `${TRANSFORMERS_URL}/books/search/${bookUUID}/?q=${term}`
    ).then( response => response.data.results || []);
}
